/**
 * paymentlinks-7days — gemeinsame Fehler-Klassifikation für den
 * Mollie-Zahlungslink-Versand (Dispatch-Buttons).
 *
 * Beide prominenten Dispatch-Pfade — die Zeilen-Aktion in
 * `PaymentsListColumns.tsx` und der Bündel-Versand in `PanelCardPaymentData.tsx`
 * — werteten den ApolloError unterschiedlich, aber strukturgleich aus. Der
 * Server liefert den handlungsweisenden Code `MOLLIE_SCOPE_MISSING` in
 * `extensions.code` (siehe server/mollie/mollie.errorCodes.ts), der zuvor im
 * generischen "später erneut versuchen"-Toast verschluckt wurde.
 *
 * Diese Datei zentralisiert die Klassifikation (rein, testbar) — die Anzeige
 * (notification.warning vs message.error) bleibt beim Caller, da der
 * Rate-Limit-Fall zusätzlich lokalen State setzt.
 */

export type MollieDispatchErrorKind = "scopeMissing" | "rateLimit" | "generic";

/**
 * Klassifiziert einen Dispatch-Fehler anhand des GraphQL-`extensions.code`.
 * Fällt für FORBIDDEN / "rate limit"-Messages auf "rateLimit" zurück, sonst
 * "generic". `MOLLIE_SCOPE_MISSING` hat Vorrang.
 */
export const classifyMollieDispatchError = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error: any,
): MollieDispatchErrorKind => {
    const code = error?.graphQLErrors?.[0]?.extensions?.code;
    const msg = error?.message || "";

    if (code === "MOLLIE_SCOPE_MISSING") {
        return "scopeMissing";
    }
    if (code === "FORBIDDEN" || /rate.?limit/i.test(msg)) {
        return "rateLimit";
    }
    return "generic";
};
